import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Vdi } from './vdi.model';
import { environment } from '../../environments/environment';

@Injectable()
export class VdiService {

  constructor(private httpClient: HttpClient) {}

  public save(data: any): Observable<any> {
    return this.httpClient.post(environment.api + '/simpleform', data);
  }

  public vdi_search(vin: string): Observable<any> {
    return this.httpClient.get<any>(environment.api + '/vdi/' + vin);
  }

  public vdi_search_pw(vin: string): Observable<any> {
    return this.httpClient.get<any>(environment.api + '/vdi_pw/' + vin);
  }
}

